export enum CARD_PAYMENTS_SIDEBAR {
  ADD_PAYMENT_METHOD = 'addPaymentMethod',
  EDIT_PAYMENT_METHOD = 'editPaymentMethod',
  REMOVE_PAYMENT_METHOD = 'removePaymentMethod',
  VIEW_BILLING_PROFILE = 'viewBillingProfile',
}

export type CreditCardBrand = 'visa' | 'amex' | 'mastercard' | string;

export type CustomerBalances = { [key: string]: number };
